import { LogoMobile } from 'src/config/components/LogoMobile';
import { useTranslation } from 'react-i18next';
import { useDrawer } from 'src/hooks/useDrawer';
import { useSettings } from 'src/modules/settings';
import { DownloadIcon } from './svg/Download';

export const PwaButton = () => {
  const { t } = useTranslation();
  const {
    pwa: { promptPwaPopup }
  } = useSettings();
  const { closeDrawer } = useDrawer();

  const handlePWA = () => {
    promptPwaPopup();
    closeDrawer();
  };

  return (
    <div
      className="w-full h-[56px] border border-solid border-pwab_border rounded-[10px] bg-pwab_bg flex justify-center items-center py-2.5 px-3 gap-2.5 cursor-pointer"
      onClick={handlePWA}>
      <LogoMobile className="w-9 h-9" isShowOriginLogo />
      <div className="flex-1 flex flex-col justify-center items-start">
        <p className="text-pwab_color_primary text-base font-medium uppercase">wizebets app</p>
        <p className="text-pwab_color_secondary text-xs font-medium">{t('pwaButton.content')}</p>
      </div>
      <DownloadIcon />
    </div>
  );
};
